export default __webpack_public_path__ + "static/media/img-02.70da5800.jpg";